<!-- The nature of the Lucide icon library is such that we can not dynamically import them; they must be explicitly named. -->
<!-- Rather than import all of them (1000s of components), we should add to both the import list and the iconMap list when we -->
<!-- need new ones. It is crucial to add to _both_ lists. -->
<template>
  <div class="t" @click="$emit('click')">
    <!-- Wrap the component in a 't' class such that we can apply our custom CSS to it -->
    <component
      :is="iconComponent"
      v-if="iconComponent"
      :size="props.size"
      :stroke-width="props.strokeWidth"
      :color="props.color"
    />
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { // Keep in sync with `iconMap`
    Activity,
    BanknoteArrowDown,
    BanknoteArrowUp,
    BellDot,
    Cake,
    ChartNoAxesCombined,
    Check,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    ChevronsLeft,
    ChevronsRight,
    Circle,
    CircleAlert,
    CircleCheck,
    CircleCheckBig,
    CircleIcon,
    FileSearch,
    FileUp,
    GlassWater,
    Handshake,
    Hash,
    House,
    Info,
    LoaderCircle,
    Medal,
    Megaphone,
    OctagonAlert,
    Pencil,
    Plus,
    RefreshCw,
    Route,
    Search,
    SendHorizontal,
    ShieldQuestion,
    Sparkles,
    Store,
    Trash,
    TriangleAlert,
    Unplug,
    UserRound,
    Video,
    Wallet,
    X,
  } from 'lucide-vue-next';

  const iconMap = { // Keep in sync with `import ... from 'lucide-vue-next'`
    Activity,
    BanknoteArrowDown,
    BanknoteArrowUp,
    BellDot,
    Cake,
    ChartNoAxesCombined,
    Check,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    ChevronsLeft,
    ChevronsRight,
    Circle,
    CircleAlert,
    CircleCheck,
    CircleCheckBig,
    CircleIcon,
    FileSearch,
    FileUp,
    GlassWater,
    Handshake,
    Hash,
    House,
    Info,
    LoaderCircle,
    Medal,
    Megaphone,
    OctagonAlert,
    Pencil,
    Plus,
    RefreshCw,
    Route,
    Search,
    SendHorizontal,
    ShieldQuestion,
    Sparkles,
    Store,
    Trash,
    TriangleAlert,
    Unplug,
    UserRound,
    Video,
    Wallet,
    X,
  };

  const props = defineProps({
    name: { type: String, required: true },
    size: { type: Number, default: null },
    strokeWidth: { type: Number, default: null },
    color: { type: String, default: null },
  });

  const iconComponent = computed(() => iconMap[props.name] || null);
</script>
